export { default } from "./SetPasswordForm";



// WEBPACK FOOTER //
// ./src/screens/Login/SetPasswordForm/index.ts